import PriceAdvisor from './PriceAdvisor';

export default PriceAdvisor;
